import React, { useState } from 'react';
import { ArrowDropDownRounded } from '@mui/icons-material';
import { Checkbox, Collapse, Stack, Typography } from '@mui/material';
import { theme } from '../../../theme';

function ReplacementCardEntry({ card, isSelected, isDisabled, onToggleSelection }) {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Stack
            aria-expanded={isExpanded}
            aria-label={`Show procedures for ${card.name}`}
            onClick={() => setIsExpanded((isOpen) => !isOpen)}
            onKeyDown={(event) => {
                if (event.target !== event.currentTarget) return;
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    setIsExpanded((isOpen) => !isOpen);
                }
            }}
            role='button'
            tabIndex={0}
            sx={{ display: 'block', width: '100%', borderRadius: 1, boxShadow: 1, textAlign: 'left', cursor: 'pointer' }}
        >
            <Stack sx={{ backgroundColor: theme.palette.background.white, borderRadius: 1 }}>
                <Stack direction='row' alignItems='center' spacing={1} p={1.25}>
                    <Checkbox
                        checked={isSelected}
                        disabled={isDisabled}
                        color='primary'
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => {
                            event.stopPropagation();
                            onToggleSelection();
                        }}
                        onKeyDown={(event) => event.stopPropagation()}
                        sx={{ p: 0.25 }}
                    />
                    <Stack sx={{ minWidth: 0, flex: 1 }}>
                        <Typography variant='normal' noWrap sx={{ fontSize: '14px', lineHeight: 1.2 }}>{card.name}</Typography>
                        <Typography variant='normal' sx={{ color: theme.palette.subtext.main, fontSize: '12px', overflowWrap: 'anywhere' }}>{card.hospital}</Typography>
                        <Typography variant='normal' sx={{ color: theme.palette.subtext.main, fontSize: '12px', whiteSpace: 'nowrap' }}>
                            Open: <Typography component='span' variant='normal' sx={{ color: theme.palette.text.primary, fontSize: 'inherit' }}>{card.openQuantity}</Typography>
                            {' | Hold: '}<Typography component='span' variant='normal' sx={{ color: theme.palette.text.primary, fontSize: 'inherit' }}>{card.holdQuantity}</Typography>
                        </Typography>
                    </Stack>
                    {/* replace with off cntract spend in the last 12 months */}
                    {card.savingsValue > 0 &&
                        <Typography variant='heavy' sx={{ ml: 'auto', color: theme.palette.green.main, fontSize: '12px', whiteSpace: 'nowrap' }}>{card.savings}</Typography>
                    }
                    <ArrowDropDownRounded sx={{ color: theme.palette.subtext.secondary, transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 200ms ease' }} />
                </Stack>
                <Collapse in={isExpanded} timeout='auto' unmountOnExit>
                    <Stack spacing={0.5} px={1.25} pb={1.25} ml={5}>
                        {card.procedures.map((procedure) => (
                            <Typography
                                key={procedure.id}
                                variant='normal'
                                sx={{
                                    color: theme.palette.subtext.main,
                                    fontSize: '12px',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {procedure.name}
                            </Typography>
                        ))}
                    </Stack>
                </Collapse>
            </Stack>
        </Stack>
    );
}

export default ReplacementCardEntry;